import React, { useEffect, useContext } from 'react'
import { View, Text, Pressable, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';

import '../../../../style/css/rule.css'
import { routeContact, routePrivacyPolicy } from '../../../../style/css/CmnStyle';
import { hpContext } from '../../HPContext'


// 特定商取引法に基づく表記
function Tokutei() {
  const { t, i18n } = useTranslation();

  const ReactGA = useContext(hpContext).ReactGA;

  const scrollHeadHeight = useContext(hpContext).scrollHeadHeight;
  const isWide = useContext(hpContext).isWide;

  useEffect(() => {
    // ログ：ページ
    ReactGA.event("pageTokuteisyou");
  }, [])

  return (
    <View style={{marginTop: scrollHeadHeight}}>
      <View style={isWide? styles.containerWide : styles.container}>

        <Text style={styles.title}>{t('tokusyohou.title')}</Text>

        <View style={styles.contentWrap}>

          <View style={styles.contentRaw}>
            <Text style={styles.label}>{t('tokusyohou.service.title')}</Text>
            <Text style={isWide? styles.textWide : styles.text}>{t('tokusyohou.service.content')}</Text>
          </View>

          <View style={styles.contentRaw}>
            <Text style={styles.label}>{t('tokusyohou.address.title')}</Text>
            <Text style={isWide? styles.textWide : styles.text}>{t('tokusyohou.address.content')}</Text>
          </View>

          <View style={styles.contentRaw}>
            <Text style={styles.label}>{t('tokusyohou.tell.title')}</Text>
            <Text style={isWide? styles.textWide : styles.text}>{t('tokusyohou.tell.content')}</Text>
          </View>

          <View style={styles.contentRaw}>
            <Text style={styles.label}>{t('tokusyohou.handling.title')}</Text>
            <Text style={isWide? styles.textWide : styles.text}>
              {t('tokusyohou.handling.content1')}
              <Pressable accessibilityRole="link" href={routePrivacyPolicy}>
                <Text>{t('policy.title')}</Text>
              </Pressable>
              {t('tokusyohou.handling.content2')}
            </Text>
          </View>

          <View style={styles.contentRaw}>
            <Text style={styles.label}>{t('tokusyohou.contact.title')}</Text>
            <Text style={isWide? styles.textWide : styles.text}>
              {t('tokusyohou.contact.content')}
              <Pressable accessibilityRole="link" href={routeContact}>
                <Text>{t('tokusyohou.contact.link')}</Text>
              </Pressable>
            </Text>
          </View>

        </View>

      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: '10%',
    marginHorizontal: '5%',
  },
  containerWide: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: '5%',
    marginHorizontal: '25%',
  },

  title: {
    fontSize: '1.5em',
    fontWeight: 'bold',
    marginVertical: 30,
  },

  contentWrap: {
    width: '100%',
  },

  contentRaw: {
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginVertical: 15,
  },

  label: {
    fontSize: '1.3em',
    fontWeight: 'bold',
    marginVertical: 3,
  },

  text: {
    fontSize: '1.1em',
    marginLeft: 20,
  },
  textWide: {
    fontSize: '1.2em',
    marginLeft: 20,
  },
});

export default Tokutei;